module.exports = __webpack_public_path__ + "media/8an-fox.4681c0cb.mp3";